import { Route, Routes, Navigate } from 'react-router-dom';
import Login from '../pages/login/Login';
import Registration from '../pages/registration/Registration';
import React from 'react';
import ForgotPassword from '../pages/fogotPassword/ForgotPassword';
import CompanyRegistrationForm from '../pages/companyAndBURegistration/CompanyRegistrationForm';
import PinkMenu from './layout/PinkMenu';
import { Box } from '@mui/material';

const RoutedApp = () => {
  return (
    <Box sx={{ display: 'flex', height: '100vh' }}>
      {/*<PinkMenu />*/}
      <Box sx={{ flexGrow: 1}}>
        <Routes>
          <Route path="/" element={<Navigate to="/login" />} />
          <Route path="/login" element={<Login />} />
          <Route path="/registration" element={<Registration />} />
          <Route path="/forgotPassword" element={<ForgotPassword />} />
          <Route path="/companyRegistration" element={<CompanyRegistrationForm />} />
        </Routes>
      </Box>
    </Box>
  );
}

export default RoutedApp;